import { Component } from '@angular/core';
import { FuseSplashScreenService } from './core/services/splash-screen.service';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from './core/services/translation-loader.service';

import { FuseNavigationService } from './core/components/navigation/navigation.service';
import { FuseAdminNavigationModel } from './navigation/admin.navigation.model';
import { locale as navigationEnglish } from './navigation/i18n/en';
import { locale as navigationTurkish } from './navigation/i18n/tr';
import { UsersDataManager } from './data/users.datamanager';
import { FuseSuperAdminNavigationModel } from './navigation/superadmin.navigation.model';

@Component({
    selector   : 'fuse-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss']
})
export class AppComponent
{
    constructor(
        private usersDataManager: UsersDataManager,
        private fuseNavigationService: FuseNavigationService,
        private fuseSplashScreen: FuseSplashScreenService,
        private translate: TranslateService,
        private translationLoader: FuseTranslationLoaderService
    )
    {
        // Add languages
        this.translate.addLangs(['en', 'tr']);

        // Set the default language
        this.translate.setDefaultLang('en');

        // Use a language
        this.translate.use('en');

        // Set the navigation model
        this.fuseNavigationService.setNavigationModel(new FuseAdminNavigationModel());

         // Set the navigation translations
         this.translationLoader.loadTranslations(navigationEnglish, navigationTurkish);
    }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/app.component.ts